import { ApplicationRoles } from '../../../constants/applicationRoles.ts';
import applicationRoutes from '../../../constants/applicationRoutes.ts';
import Layout from '../../../app/Layout.tsx';
import { RouteAuthenticationRequirement, RouteItem } from '@invara-dev/react-base';

export const HotelSearchNavItem: RouteItem = {
  text: 'Hotel Search',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [ApplicationRoles.staff],
  layout: <Layout />,
  path: applicationRoutes.agent.obtInquiry,
  async lazy() {
    const component = await import('../../../features/activities/hotelSearch/HotelSearchContainer.tsx');
    return { Component: component.HotelSearchContainer };
  }
};

export const AgentQuerySubItems: RouteItem = {
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [ApplicationRoles.staff],
  layout: <Layout />,
  subItems: [
    {
      path: `${applicationRoutes.agent.obtInquiry}/:id`,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: [ApplicationRoles.staff],
      async lazy() {
        const component = await import('../../../features/activities/hotelSearch/HotelSearchContainer.tsx');
        return { Component: component.HotelSearchContainer };
      }
    }
  ]
};
export const ThirdPartyPaymentDetailsItem: RouteItem = {
  text: 'Third-Party Payment Details Viewer',
  disableDefaultNavItem: true,
  authenticationRequirement: RouteAuthenticationRequirement.Either,
  path: applicationRoutes.account.thirdPartyPaymentDetailsViewer,
  layout: <Layout />,
  async lazy() {
    const component =
      await import('../../../features/thirdPartyPaymentDetailsViewer/ThirdPartyPaymentDetailsViewer.tsx');
    return { Component: component.ThirdPartyPaymentDetailsViewer };
  }
};

export const ContractSignRouteItem: RouteItem = {
  text: 'Contract signature',
  disableDefaultNavItem: true,
  authenticationRequirement: RouteAuthenticationRequirement.Either,
  path: applicationRoutes.account.contractSign,
  layout: <Layout forceUnauthenticatedNav={true} />,
  async lazy() {
    const component = await import('../../../features/companyProjects/contractSigning/ContractSignRedirectPage.tsx');
    return { Component: component.ContractSignRedirectPage };
  }
};
